"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[天枢] Global Error:", error.message, error.digest);
  }, [error]);

  return (
    <html lang="zh_CN">
      <body className="antialiased">
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f8fafc] to-[#f1f5f9]">
          <div className="text-center space-y-4 max-w-md px-6">
            <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center bg-red-50 border border-red-200">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900 mb-2">页面加载异常</h1>
              <p className="text-sm text-gray-500">
                天枢系统遇到了一些问题，请尝试刷新页面
              </p>
            </div>
            <div className="flex items-center gap-3 justify-center">
              <button
                onClick={() => reset()}
                className="px-4 py-2 rounded-lg bg-[#2563EB] text-white text-sm hover:bg-[#1d4ed8] transition-colors"
              >
                重试
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm hover:bg-gray-200 transition-colors"
              >
                刷新页面
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
